import { render } from "./FormProductDetails.vue?vue&type=template&id=255dfd1e&scoped=true"
import script from "./FormProductDetails.vue?vue&type=script&lang=js"
export * from "./FormProductDetails.vue?vue&type=script&lang=js"

import "./FormProductDetails.vue?vue&type=style&index=0&id=255dfd1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-255dfd1e"

export default script